import { Group, Popover } from '@mantine/core'
import { IconThumbUp } from '@tabler/icons-react'
import { useState } from 'react'
import { ReactComponent as ThumbsUpIcon } from '../assets/thumbs_up.svg'
import { ReactComponent as PartyingFaceIcon } from '../assets/partying_face.svg'
import { ReactComponent as RocketIcon } from '../assets/rocket.svg'
import { Reaction, useCreatePostReaction } from './api'
import { useQueryClient } from '@tanstack/react-query'
import classes from './Socials.module.css'

export default function ReactionsPopover({
  post_id,
  isRoar,
}: {
  post_id: number
  isRoar: boolean
}) {
  const [opened, setOpened] = useState<boolean>(false)
  const queryClient = useQueryClient()
  const { mutate: createPostReaction } = useCreatePostReaction()

  function handleAddReaction(reaction: Reaction) {
    createPostReaction(
      {
        kind: 'post',
        post_id: post_id,
        reaction_type: reaction,
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            queryKey: ['arenaPosts'],
          })
          setOpened(false)
        },
      }
    )
  }

  return (
    <Popover
      opened={opened}
      position="top"
      withArrow
      onDismiss={() => setOpened(false)}
    >
      <Popover.Target>
        <IconThumbUp
          className={classes.reactionsIcon}
          color={isRoar ? '#ffffff' : '#adb5bd'}
          onClick={() => setOpened(true)}
        />
      </Popover.Target>
      <Popover.Dropdown>
        <Group gap="xs">
          <ThumbsUpIcon
            width={16}
            height={16}
            onClick={() => handleAddReaction('thumbs_up')}
          />
          <PartyingFaceIcon
            width={16}
            height={16}
            onClick={() => handleAddReaction('partying_face')}
          />
          <RocketIcon
            width={16}
            height={16}
            onClick={() => handleAddReaction('rocket')}
          />
        </Group>
      </Popover.Dropdown>
    </Popover>
  )
}
